import { type ReactNode, useMemo } from 'react';

import type { ResourceColorName } from '../../../theme/tokens/resourcesColors';
import type { ResourceMenuItem } from '../../organisms/ResourceMenuActions';

export type ResourceTimelineItemColor = ResourceColorName;
export type ResourceTimelineItemVariant = 'short' | 'long';
export type ResourceTimelineItemAction = ResourceMenuItem;

export type ResourceTimelineItemProps = {
  color: ResourceTimelineItemColor;
  variant?: ResourceTimelineItemVariant;
  title: string;
  subtitle?: string;
  children?: ReactNode;
  action?: ReactNode;
  actions?: (ResourceTimelineItemAction | null | undefined | false)[];
  actionsButtonTooltip?: string;
  actionsButtonAriaLabel?: string;
  'data-testid'?: string;
};

export function useResourceTimelineItem(props: ResourceTimelineItemProps) {
  const variant = props.variant ?? 'long';
  const isShort = variant === 'short';
  const hasSubtitle = props.subtitle !== undefined && props.subtitle.trim() !== '';
  const hasChildren = !isShort && props.children !== undefined && props.children !== null && props.children !== '';

  const actions = useMemo(() => {
    return (props.actions ?? []).filter(Boolean) as ResourceTimelineItemAction[];
  }, [props.actions]);

  const hasActions = actions.length > 0;

  return {
    variant,
    isShort,
    hasSubtitle,
    hasChildren,
    actions,
    hasActions,
    actionsButtonTooltip: props.actionsButtonTooltip,
    actionsButtonAriaLabel: props.actionsButtonAriaLabel,
  };
}
